const SNAKE_CASE = 'snakeCase';
const KEBAB_CASE = 'kebabCase';

export function snakeCase(str) {
    return format(SNAKE_CASE, str);
}

export function kebabCase(str) {
    return format(KEBAB_CASE, str);
}

export function format(type, str) {
    const containsNumbers = /\d/.test(str);
    if (containsNumbers) return str;

    str = reformatLatin(str);

    switch (type) {
        case KEBAB_CASE:
            str = str.replace(/[A-Z]/g, match => '-' + match)
                .replace(/([^a-zA-Z])-([A-Z])/g, match => match[0] + match[2])
                .replace(/^-/, '')
                .replace(/[^a-zA-Z0-9:]+/g, '-')
                .toLowerCase();
            break;
        case SNAKE_CASE:
            str = str.replace(/[A-Z]/g, match => '_' + match)
                .replace(/([^a-zA-Z])_([A-Z])/g, match => match[0] + match[2])
                .replace(/^_/, '')
                .replace(/[^a-zA-Z0-9:]+/g, '_')
                .toLowerCase();
            break;
    }

    const isLastCharUnderscoreOrDash = str.charAt(str.length - 1) === '_' || str.charAt(str.length - 1) === '-';
    if (isLastCharUnderscoreOrDash) {
        str = str.slice(0, -1);
    }

    return str;
}

export function capitalizeFirstLetter(string) {
    if (!string) return '';

    const lower = string.toLowerCase();
    return string.charAt(0).toUpperCase() + lower.slice(1);
}

export function capitalizeEveryWordsFirstLetter(string) {
    const arr = string.split(" ");

    for (let i = 0; i < arr.length; i++) {
        arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);

    }

    return arr.join(" ");
}

export function numToAlphabetLetter(num) {
    if (typeof num !== 'number' || num < 1 || num > 26) {
        return -1;
    }

    const startOfCapitalLetterCodes = 64;
    return String.fromCharCode(num + startOfCapitalLetterCodes);
}

export default function reformatLatin(word) {
    $.each({
        "ā": "a",
        "č": "c",
        "ē": "e",
        "ģ": "g",
        "ī": "i",
        "ķ": "k",
        "ļ": "l",
        "ņ": "n",
        "š": "s",
        "ū": "u",
        "ž": "z",
        "Ā": "A",
        "Č": "C",
        "Ē": "E",
        "Ģ": "G",
        "Ī": "I",
        "Ķ": "K",
        "Ļ": "L",
        "Ņ": "N",
        "Š": "S",
        "Ū": "U",
        "Ž": "Z",
        "Õ": "O",
        "õ": "õ",
        "Ä": "A",
        "ä": "a",
        "Ü": "U",
        "ü": "u",
        "Ą": "A",
        "ą": "a",
        "Ę": "E",
        "ę": "e",
        "Ė": "E",
        "ė": "e",
        "Ų": "U",
        "ų": "u"
    }, function(h, m) {
        word = word.replace(new RegExp(h,"g"), m)
    });
    return word;
}